var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        ref: "form",
        staticClass: "mb-3 login-pwd-reset",
        attrs: { method: "post" }
      },
      [
        _c(
          "div",
          { staticClass: "input-unit", attrs: { "data-validate": "mail" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              attrs: {
                type: "email",
                name: "email",
                autocomplete: "email",
                "data-testing": "guest-login-input",
                id: _vm._uid,
                "data-autofocus": ""
              },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm._uid } }, [
              _vm._v(_vm._s(_vm.$translate("Ceres::Template.loginEmail")) + "*")
            ])
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "error-msg" }, [
          _vm._v(
            _vm._s(_vm.$translate("Ceres::Template.loginEnterConfirmEmail"))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-medium btn-appearance",
              class: _vm.buttonSizeClass,
              attrs: {
                disabled: _vm.isDisabled,
                "data-testing": "guest-login-button"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.validate($event)
                }
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$translate("Ceres::Template.loginNext")) +
                  "\n                "
              ),
              _c("icon", {
                attrs: { icon: "arrow-right", loading: _vm.isDisabled }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }